(function() {
'use strict';

angular
    .module('transfers')
    .service('transferSearch', transferSearch);

function transferSearch($http, occupancyService, transferSearchValidator, searchUnitService, $q, tripService, analytics) {
    const domain = TRPCONFIG.Domain;
    const req = {
        CultureCode: domain.CultureCode,
        CurrencyCode: domain.CurrencyCode,
        DomainId: domain.DomainId,
        TradingGroupId: domain.TradingGroup
    };
    let results;
    let inProgress;
    const url = '/api3/transfers/availability/';

    const service = {
        validateSearchCriteria,
        clearSearchResults,
        getSearchResults,
        search,
        getAvailabilityRequest,
        getUrl,
        getTransfersTimeApprovalRequired
    };

    function _doRequest(r, newSearch) {
        let storage = sessionStorage.getItem('storeSelectedFlight');
        if (storage) {
            let selectedFlight = JSON.parse(storage);
            r.ArrivalDate = selectedFlight.Legs[0].ArrivalDate;
        }
        return newSearch ?
            $http.post(`${url}get`, r) :
            $http.post(`${url}getfromsession`, { AvailabilitySearchId: r.AvailabilitySearchId }, { ignoreErrors: true });
    }

    function validateSearchCriteria(options) {
        options = options || {};
        let start = searchUnitService.startDate(searchUnitService.transfer);
        let end = searchUnitService.endDate(searchUnitService.transfer);
        const transfersTimeApprovalRequired = getTransfersTimeApprovalRequired(options.enableTransfersTimeApproval);
        if (transfersTimeApprovalRequired) {
            if (!searchUnitService.isStartTimeApprovedByCustomer(searchUnitService.transfer)) {
                start = null;
            }
            if (!searchUnitService.isEndTimeApprovedByCustomer(searchUnitService.transfer)) {
                end = null;
            }
        }
        return transferSearchValidator.validate(
            searchUnitService.getDestinationAirport(),
            searchUnitService.getResort(),
            searchUnitService.getDirection(),
            start,
            end,
            occupancyService.reduceOccupancy(),
            searchUnitService.getLocationId(),
            searchUnitService.getTransferType(),
            searchUnitService.getTransferPickUpPoint(),
            searchUnitService.getTransferDropOffPoint());
    }

    function clearSearchResults() {
        results = null;
    }

    function getSearchResults(searchId, tripId) {
        if (results && results !== 'null') {
            return $q.when(_.cloneDeep(results));
        }
        return search({ searchId, tripId });
    }

    function search(args) {
        if (inProgress != null && !args.newSearch) {
            return inProgress;
        }
        req.AvailabilitySearchId = args.searchId;
        req.TripId = args.tripId;
        if (args.newSearch) {
            const transferType = searchUnitService.getTransferType();
            if (!TRPCONFIG.Domain.PointToPointTransferSearchEnabled && transferType === searchUnitService.transferTypes.AirportTransfer) {
                req.DestinationAirport = searchUnitService.getDestinationAirport();
                req.AirportCode = req.DestinationAirport.Code;
                const route = searchUnitService.getRoute();
                if (route) {
                    req.Route = route;
                } else {
                    const location = searchUnitService.getLocationId();
                    req.LocationId = location || 0;
                }
            } else {
                const pickUpPoint = searchUnitService.getTransferPickUpPoint();
                const dropOffPoint = searchUnitService.getTransferDropOffPoint();
                req.Route = {
                    PickUpPoint: pickUpPoint,
                    DropOffPoint: dropOffPoint
                };
            }

            req.IsFlightPlus = args.isFlightPlus;

            //Note we are deliberately cocking up the dates because we have to
            req.ArrivalDate = searchUnitService.requiresStartDate() ? searchUnitService.startDate(searchUnitService.transfer) : null;
            req.ReturnDate = searchUnitService.requiresEndDate() ? searchUnitService.endDate(searchUnitService.transfer) : null;
            req.BalanceDueDateOverride = args.BalanceDueDateOverride;
        } else if (args.searchId === '00000000-0000-0000-0000-000000000000') {
            //we get an empty guid back from the availability call when there are no results.
            //This means that there will be nothing in the session so we can just return an empty array
            return $q.when([]);
        }
        analytics.startTimer('TransfersAvailabilityRequest');
        inProgress = tripService.getTripReducedOccupancy(req.TripId).then(occ => {
            occ = occ || occupancyService.reduceOccupancy();
            req.Adults = occ.Adults;
            req.ChildAges = occ.ChildAges;
            const pax = req.Adults + req.ChildAges.length;
            if (args.newSearch) {
                tripService.recordTransferSearch(args.tripId, req);
            }
            return _doRequest(req, args.newSearch)
                .then(function(res) {
                    analytics.endTimer('TransfersAvailabilityRequest');
                    req.AvailabilitySearchId = res.data.AvailabilitySearchId;
                    results = res.data.Transfers;
                    inProgress = null;
                    enrichData(results, pax);
                    return _.cloneDeep(results);
                }, function() {
                    inProgress = null;
                    results = null;
                });
        });
        return inProgress;
    }

    function getAvailabilityRequest() {
        return req;
    }

    function getUrl() {
        return url;
    }

    function enrichData(transfers, totalPax) {
        angular.forEach(transfers, function(transfer) {
            transfer.PerPersonPrice = transfer.TotalPrice / totalPax;
        });
    }

    function getTransfersTimeApprovalRequired(enableTransfersTimeApproval) {
        return enableTransfersTimeApproval && TRPCONFIG.Domain.DeviceType !== 'Mobile';
    }

    return service;
}
})();
